import http from 'plugins/axios';

export default {
  getAllCoins() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getWithdrawCoinAddressList({userId, coinType, address, chain, page, size}) {
    return http.get({
      url: '/admin/trade/user/userWithdrawAddress',
      data: {
        userId,
        coinType,
        address,
        chain,
        page,
        size
      }
    });
  }
};
